import html2canvas from "html2canvas";

export function captureScreenshot(fileName = 'screenshot.png') {
  if (typeof fileName !== 'string') fileName = 'screenshot.png'
  html2canvas(document.body, {
    useCORS: true,
  }).then(canvas => {
    canvas.toBlob(blob => {
      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(blob);
      downloadLink.download = fileName;
      downloadLink.click();
    }, 'image/png');
  })
}
